module.exports = {
  label: {
    headerTitle: 'Questionnaires',
    AddheaderTitle: 'Add Questionnaires',
    EditheaderTitle: 'Edit Questionnaires',
    questionnaires: 'Questionnaires',
    search: 'Search...',
    showPagination: {
      showing: 'Showing',
      to: 'to',
      of: 'of',
      entries: 'entries',
      rowsSelected: 'rows selected'
    },
    tooltips: {
      delete: 'Delete',
      edit: 'Edit'
    },
    buttons: {
      add: 'Add',
      save: 'Save',
      cancel: 'Cancel'
    }
  }
};
